import PropTypes from 'prop-types';
import { formatPhoneNumber } from '../NumberFormatter';

const LinePreview = ({ formData }) => {
  const getDirection = (text) => {
    const rtlChars = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return rtlChars.test(text) ? 'rtl' : 'ltr';
  };

  const getFullLineText = () => {
    const content = (formData.content || '').trim();

    const contacts = [
      formData.mobile ? formatPhoneNumber(formData.mobile) : '',
      formData.whatsapp ? formatPhoneNumber(formData.whatsapp) : '',
      formData.email ? formData.email : '',
    ].filter(Boolean);

    let fullText = content;
    if (contacts.length > 0) {
      fullText += (content.endsWith('.') ? ' ' : ', ') + contacts.join(', ');
    }

    return fullText;
  };

  // Split text into selected number of lines
  const splitIntoLines = (text, lineCount) => {
    if (!lineCount || lineCount < 1) return [text];

    const words = text.split(/\s+/);
    const avgWordsPerLine = Math.ceil(words.length / lineCount);
    const lines = [];

    for (let i = 0; i < words.length; i += avgWordsPerLine) {
      lines.push(words.slice(i, i + avgWordsPerLine).join(' '));
    }

    return lines;
  };

  const fullText = getFullLineText();
  const lineCount = parseInt(formData.size || '1', 10); // selected lines
  const lines = splitIntoLines(fullText, lineCount);

  const contentFontSize = formData.contentfs || '8px';
  const contentDir = getDirection(fullText);

  return (
    <div className="mt-4 text-gray-900" style={{ width: '108pt' }}>
      {/* Render each selected line */}
      {lines.map((line, idx) => (
        <div
          key={idx}
          style={{
            fontSize: contentFontSize,
            textAlign: 'justify',         // ✅ left-justified
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
          }}
          dir={contentDir}
        >
          {line}
        </div>
      ))}

      {/* Agency Footer */}
      {formData.agency && (
        <div className="mt-0 flex items-center w-full">
          <div className="flex-grow border-b border-gray-700" />
          <span className="px-1 text-sm font-semibold text-gray-800">
            {formData.agency}
          </span>
          <div className="flex-grow border-b border-gray-700" />
        </div>
      )}
    </div>
  );
};

LinePreview.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default LinePreview;
